
import React, { useEffect, useState, useRef } from "react";
import Process from "./VirtualTerminal/Process";
import RequestBuilder from "./RequestBuilder/RequestBuilder";
import ResponseBuilder from "./ResponseBuilder/ResponseBuilder";
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { ConfirmDialog, InformationBox } from "../Common/ConfirmDialog";
import { SetAuthHeader } from "../../Services/ServiceEngine";
import Countdown from "react-countdown";
import RequestSequence from "./RequestSequence/RequestSequence";
import { toast } from "react-toastify";
import { AddSequence, AddTransactionToSequence, StartSimulation, StopSimulation, UpdateSequence, UpdateSimulation } from "../../Redux/Features/Simulation/SimulationServicesSlice";
import { useDispatch, useSelector } from "react-redux";
import { SimulationTypeCancel, SimulationTypeLinkTerminal, SimulationTypeTxnStatus, SimulationTypeUnLinkTerminal } from "./Constants";
import { DEFAULT_TERMINAL, PUBLIC_SWAGGER_URL, SIMULATION_HUB } from "../../Configs";
import { guideMeConfig } from "./GuideMe.js";

const Simulator = props => {
    const [token, setToken] = useState(null);
    const [linkedTerminal, setLinkedTerminal] = useState(false);
    const [terminalId, setTerminalId] = useState(''); // Initialize with an empty string
    const [connected, setConnected] = useState(true);

    //New transaction request just received to the simulator. 
    //For the request and response mapping, please use onlineAPI reference id
    const [receivedNewMessage, setReceivedMessage] = useState(null)

    //New transaction response just received to the simulator. 
    //For the request and response mapping, please use onlineAPI reference id
    const [receivedResponseMessage, setReceivedResponseMessage] = useState(null)

    //Based on the selection of transaction sequence list, request and response will be showed.
    const [requestInformation, setRequestInformation] = useState(null);

    const [newTransactionForTerminal, setNewTransactionForTerminal] = useState(null);

    const [hubConnection, setHubConnection] = useState(null);
    const [connectionUpdated, setConnectionUpdated] = useState(false);

    const [terminalModel, setTerminalModel] = useState(null);

    const [showInfoConfirmModal, setShowInfoConfirmModal] = useState(false);

    const [modalContents, setModalContents] = useState({
        "header": "Start New Debugging",
        "content": "A new debug point has been encountered, necessitating further progression in the debugging process."
    });

    const [currentGuide, setCurrentGuide] = useState(null);

    const guideMeContainer = useRef(null);
    const guideMeSelector = useRef(null);
    const guideMeActionBox = useRef(null);

    const RECEIVED_STATUS = 1
    // useDispatch() hook is equivalent of mapDispatchToProps.
    const dispatch = useDispatch();

    const simulation = useSelector((state) => state.simulation);

    // create signalR connection
    const createHubConnection = async () => {
        const connection = new HubConnectionBuilder()
            .withUrl(SIMULATION_HUB)
            .withAutomaticReconnect()
            .configureLogging(LogLevel.Information)
            .build();

        connection.keepAliveIntervalInMilliseconds = 1000;
        connection.serverTimeoutInMilliseconds = 6000;

        try {
            await connection.start();
            // update the connection with new connection id.
            dispatch(StartSimulation(connection.connectionId, function (response, success) {
                setHubConnection(connection);
            }));
        } catch (error) {
        }
    };

    useEffect(() => {
        return () => {
            //current signalR connection id is getting expired, so stop the current simulation.
            dispatch(StopSimulation(function (response, success) {

            }));
            if (hubConnection) {
                hubConnection.stop();
            }
        };
    }, []);

    useEffect(() => {
        let connectionTimeout;

        if (hubConnection != null) {
            //terminal linking
            hubConnection.on('NotifyTerminalLinkRequest', (message) => {
                SetAuthorisationToken(message)
                setReceivedMessage(message)
                toast.info("Terminal link request received");
            });

            //terminal un-linking
            hubConnection.on('NotifyTerminalUnLinkRequest', (message) => {
                SetAuthorisationToken(message)
                setReceivedMessage(message)
                toast.info("Terminal unlink request received");
            });

            //This message is need to trigger terminal, If terminal currenly processing any transaction.
            //need to reject by updating validationType.
            hubConnection.on('NotifyPurchaseRequest', (message) => {
                SetAuthorisationToken(message)
                setReceivedMessage(message)
                toast.info("Purchase transaction request received");
            });

            //This message is need to trigger terminal, If terminal currenly processing any transaction.
            //need to reject by updating validationType.
            hubConnection.on('NotifyRefundRequest', (message) => {
                SetAuthorisationToken(message)
                setReceivedMessage(message)

                toast.info("Refund transaction request received");
            });

            //This message is need to trigger terminal, If terminal currenly processing any transaction.
            //need to reject by updating validationType.
            hubConnection.on('NotifyReversalRequest', (message) => {
                SetAuthorisationToken(message)
                setReceivedMessage(message)

                toast.info("Reversal transaction request received");
            });

            //This message is need to trigger terminal, If terminal currenly processing any transaction.
            //need to reject by updating validationType.
            hubConnection.on('NotifyCancelRequest', (message) => {
                SetAuthorisationToken(message)
                setReceivedMessage(message)

                toast.info("Cancel transaction request received");
            });

            //This message don't need trigger. by this message we just need send back transaction status to the client.
            hubConnection.on('NotifyPoolingRequest', (message) => {
                SetAuthorisationToken(message)
                setReceivedMessage(message)
            });

            hubConnection.on('NotifyCommonResponse', (message) => {
                setReceivedResponseMessage(message)
            });
        } else {
            // if hub connection null then create 
            createHubConnection();
            // Start a 180-second timeout for connection establishment
        connectionTimeout = setTimeout(() => {
            toast.error("An error is occurring when creating the signalR connection");
        }, 180000);
        }

    return () => {
        // Clear the timeout if the component is unmounted or the connection is established before timeout
        if (connectionTimeout) {
            clearTimeout(connectionTimeout);
        }
        };
    }, [hubConnection]);

    useEffect(() => {
        if(hubConnection?.connectionId != null){
            console.log("3 hubConnection.connectionId ", hubConnection.connectionId)
        }
    },[hubConnection?.connectionId])

    useEffect(() => {
        //stop on going 
        if (currentGuide != null) {
            clickStopGuide();
        }

        if (token != null) {
            SetAuthHeader(token, hubConnection.connectionId);
        }
        if (receivedNewMessage != null) {
            var validationType = null;
            var isOk = false;
            //any message received to the simulator, it will be hit this place.
            //but, if any financial transaction currently processing in the terminal, it should be rejected based on the transaction type
            //purchase, refund, reversal request cannot be procees if any transaction is processing on simulation.
            //for the cancel transaction, abort currently started transaction.
            if (receivedNewMessage.type == SimulationTypeLinkTerminal) {
                if (linkedTerminal) {
                    validationType = {
                        "category": 1,
                        "value": 103 // terminal-already-linked
                    }
                } else {
                    isOk = true;
                }
            } else if (receivedNewMessage.type == SimulationTypeUnLinkTerminal) {
                if (!linkedTerminal) {
                    validationType = {
                        "category": 1,
                        "value": 103
                    }
                } else {
                    isOk = true;
                }
            }
            else if (receivedNewMessage.type == SimulationTypeTxnStatus) {
                isOk = false;
            }
            else {
                if (connected) {
                    //validate terminal first
                    var payload = receivedNewMessage.requestBody
                    if (payload.terminalId !== terminalId) {
                        var validationType = {
                            "category": 1,  //validation type
                            "value": 2 // terminal not found
                        }
                        notifyBackendWithResult(validationType);
                    } else {

                        //For others
                        if (simulation.CurrentTransaction == null) {
                            if (linkedTerminal) {
                                //there is no transaction in-progress on the terminal
                                //In that case, we should notifu backend with transaction-not-found validation type for cancel request and get txn status request,
                                if (receivedNewMessage.type == SimulationTypeCancel) {
                                    //Notify backend with transaction-not-foud validation type
                                    validationType = {
                                        "category": 1,
                                        "value": 18 // transaction not found
                                    }
                                } else {
                                    isOk = true;
                                }
                            } else {
                                //If linkedTerminal is false, we cannot do financial transactions with terminal.
                                //Now we should notifyBackend result with transaction-not-found validation type
                                //Notify backend with terminal-not-linked validation type
                                validationType = {
                                    "category": 1,
                                    "value": 102 // Terminal not linked
                                }
                            }
                        } else {
                            if (linkedTerminal) {
                                //currently terminal busy with another transaction.
                                //update validation type and simulation back-end will decide
                                //but only cancel request and retrive transaction status request can be enter to terminal even txn is proccesing on the termial.
                                if (receivedNewMessage.type == SimulationTypeCancel) {
                                    isOk = true;
                                } else {
                                    //Notify backend with terminal-busy validation type
                                    validationType = {
                                        "category": 1,
                                        "value": 9 // terminal busy
                                    }
                                }
                            } else {
                                //If linkedTerminal is false, we cannot do financial transactions with terminal.
                                //Now we should notifyBackend result with transaction-not-found validation type
                                //Notify backend with terminal-not-linked validation type
                                validationType = {
                                    "category": 1,
                                    "value": 102 // Terminal not linked
                                }
                            }
                        }
                    }
                } else {
                    validationType = {
                        "category": 1,
                        "value": 23 // No SignalR connection found for the terminal
                    }
                }
            }

            if (isOk) {
                //After send transaction to terminal, you should do the automatic pre-request validation based on the request payload
                setNewTransactionForTerminal(receivedNewMessage);
            } else {
                if (validationType != null) {
                    notifyBackendWithResult(validationType);
                }
            }
            // update transaction sequence with new received message.
            // use redux store for store transaction sequence
            dispatch(AddSequence(receivedNewMessage));
        }
    }, [receivedNewMessage, token])

    useEffect(() => {
        if (receivedResponseMessage != null) {
            dispatch(UpdateSequence(receivedResponseMessage))
        }
    }, [receivedResponseMessage])

    useEffect(() => {
        if (simulation.TransactionSequence.length > 0 && receivedNewMessage != null) {
            //find the transaction information by indentifier.
            let txnRequestInformation = simulation.TransactionSequence.find((item) => item.identifier == receivedNewMessage.identifier)
            setRequestInformation(txnRequestInformation);
        }
    }, [simulation.TransactionSequence])

    useEffect(() => {
        //do the effective guide me for the user.
        if (currentGuide != null) {
            drawGuideMe(currentGuide)
        }
    }, [currentGuide])

    const SetAuthorisationToken = (message) => {
        let item = message?.headers.find((item) => { return item.key === "Authorization" });
        let token = item && item?.value
        setToken(token)
    }

    const terminalModelSelection = (value) => {
        setTerminalModel(value)
    }

    const continueConfirmModal = () => {
        setShowInfoConfirmModal(false)
    }

    const closeConfirmModal = () => {
        setShowInfoConfirmModal(false)
    }

    // Random component
    const Completionist = () => {
    };

    // Renderer callback with condition
    const renderCountDown = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            Completionist();
        }
        // Render a countdown
        return (
            <span className="input-group-text">
                <h5 style={{ fontWeight: "bold" }}>{minutes}:{seconds}</h5>
            </span>
        );
    };

    const stopSimulation = () => {
    }

    const notifyBackendWithResult = (type) => {
        var requiredUpdate = false;
        if (type.category == 1) {
            var payload = {
                "validationType": type.value,
                "originalOnlineAPIRefId": receivedNewMessage?.onlineAPIRefId != null ? receivedNewMessage?.onlineAPIRefId : simulation.CurrentTransaction?.onlineAPIRefId,
                "simulationIdentifier": receivedNewMessage.identifier
            }
            //CHANGE LOGIC DEPENDENCY notifyBackendWithResult FUNC
            if (type.value > 1) {
                toast.error("Triggered validation error!")
            } else {
                toast.info("Proccesing Started!")
            }
            requiredUpdate = true;
        } else if (type.category == 2) {
            var payload = {
                "resultType": type.value,
                "originalOnlineAPIRefId": simulation.CurrentTransaction?.onlineAPIRefId,
                "simulationIdentifier": simulation.CurrentTransaction?.identifier
            }
            toast.info("Transaction processing completed!")
            requiredUpdate = true;
        } else if (type.category == 3) {
            var payload = {
                "validationType": type.value,
                "simulationIdentifier": receivedNewMessage.identifier
            }
            requiredUpdate = true;
            toast.info("Linking/unlinking process completed!")
        }
        if (requiredUpdate) {
            dispatch(UpdateSimulation(payload, function (response, success) {

            }));
        }
    }

    const updateSimulationWithResult = (type) => {
        notifyBackendWithResult(type);
    }

    //update request and response content of simulator based on the selection of transacation sequence.
    const updateContentBasedOnSelectedRequest = (selectedRequest) => {
        setRequestInformation(selectedRequest);
    }

    const copyConnectionId = () => {
        if (hubConnection != null) {
            navigator.clipboard.writeText(hubConnection.connectionId);
            var copyDiv = document.getElementById("copy-message");
            copyDiv.classList.add("show");
            copyDiv.classList.remove("hide");
            setTimeout(() => {
                copyDiv.classList.add("hide");
                copyDiv.classList.remove("show");
            }, 1500);
        }
    };

    const linkTerminal = (e) => {
        let newState = e.target.checked
        // Check if the new value is different from the current value
        if (linkedTerminal !== newState) {
            // Update the state only if the new value is different
            setLinkedTerminal(newState)
        }
    }

    const terminalConnect = (e) => {
        let newState = e.target.checked
        // Check if the new value is different from the current value
        if (connected !== newState) {
            // Update the state only if the new value is different
            setConnected(newState)
        }
    }

    const updateTerminalLinkedState = (state) => {
        // Check if the new value is different from the current value
        if (linkedTerminal !== state) {
            // Update the state only if the new value is different
            setLinkedTerminal(state)
        }
    }

    const updateTerminalConnectedState = (state) => {
        // Check if the new value is different from the current value
        if (connected !== state) {
            // Update the state only if the new value is different
            setConnected(state)
        }
    }

    const updateTerminalId = (state) => {
        // Check if the new value is different from the current value
        if (terminalId !== state) {
            // Update the state only if the new value is different
            setTerminalId(state)
        }
    }


    const drawGuideMe = (currentGuide) => {
        var targetSelector = document.querySelector(currentGuide.element);
        var rect = targetSelector.getBoundingClientRect();
        var top = rect.top;
        var left = rect.left;
        var width = rect.width;
        var height = rect.height;

        //set it to guideMeSelector
        var guideMeElement = guideMeSelector.current
        guideMeElement.style.top = top + 'px';
        guideMeElement.style.left = left + 'px';
        guideMeElement.style.width = width + 'px';
        guideMeElement.style.height = height + 'px';

        var guideMeBox = guideMeActionBox.current
        var topPosition = top + height + 3;
        var leftPosition = left + 3;
        guideMeBox.style.top = topPosition + 'px'
        guideMeBox.style.left = leftPosition + 'px'
    }

    const handleGuideMe = () => {
        var firstGuide = guideMeConfig.steps[0];
        firstGuide.index = 0
        setCurrentGuide(firstGuide);
        var container = guideMeContainer.current
        container.classList.add("show")
    }

    const clickNextGuide = () => {
        var nextIndex = currentGuide.index + 1;
        if (guideMeConfig.steps.length > nextIndex) {
            var nextGuide = guideMeConfig.steps[nextIndex];
            nextGuide.index = nextIndex
            setCurrentGuide(nextGuide);
        } else {
            toast.info("Tour guide is completed.")
            clickStopGuide();
        }
    }

    const clickStopGuide = () => {
        var container = guideMeContainer.current
        container.classList.remove("show")
    }

    const helpIconStyles = {
        backgroundImage: `url('./assets/images/help-icon.png')`
    };

    const closeSimulationInfoBox = () => {
        var newState = false;
        if (connectionUpdated !== newState) {
            setConnectionUpdated(newState)
        }
    };

    return (
        <>
            <div className="page-content">
                {hubConnection == null &&
                    <div className="main-loader"  >
                        <div className="main-loader__txt">
                            <span>HI DEVELOPER!</span><br />
                            <span>WE ARE CREATING SIMULATION WORKSPACE FOR YOU.</span>
                        </div>
                        <img src="/assets/images/loading.svg" alt="loader" />
                    </div>
                }
                <InformationBox start={connectionUpdated} title={"Simulation Connection Details"} handleClose={() => closeSimulationInfoBox()}>
                    <div style={{ fontSize: '14px' }}>
                        <p>New connection details are assigned to the simulator, So please refresh client side with update connection Id.</p>
                        <p>It will provide best experience of your simulation.</p>
                        <div className="input-group mb-3">
                            <label className="input-group-text" for="inputGroupSelect01"><b>Connection Id</b>: {hubConnection && hubConnection.connectionId}</label>
                            <span className="input-group-text copy-btn" title="Copy" onClick={(e) => copyConnectionId()}><i className="fa fa-copy"></i></span>
                            <span id="copy-message" className="copy-confirmmessage hide">Copied &#x2713;</span>
                        </div>
                    </div>
                </InformationBox>
                <ConfirmDialog onConfirm={continueConfirmModal} handleClose={closeConfirmModal} start={showInfoConfirmModal} message={modalContents.content} title={modalContents.header}></ConfirmDialog>
                <div className="simulator">
                    <div className="details-area" style={{ backgroundColor: "#FFF" }}>
                        <div className="request-control-view">
                            <div className="session-mgt-area">
                                <div id="session-id" className="session-id input-group mb-3">
                                    <label className="input-group-text" for="inputGroupSelect01"><b>Connection Id</b>: {hubConnection && hubConnection.connectionId}</label>
                                    <span className="input-group-text copy-btn" title="Copy" onClick={(e) => copyConnectionId()}><i className="fa fa-copy"></i></span>
                                    <span id="copy-message" className="copy-confirmmessage hide">Copied &#x2713;</span>
                                </div>
                                <div className="countdown-area input-group mb-3">
                                    {/* {currentTransaction && <span className="input-group-text">
                                        <i className="fa-solid fa-stop fa-xl" style={{ color: "#c20000" }}></i>
                                    </span>}
                                    {currentTransaction == null && <span className="input-group-text" onClick={(e) => stopSimulation()}>
                                        <i className="fa-solid fa-record-vinyl  fa-xl" style={{ color: "#9e9e9e" }}></i>
                                    </span>}
                                    <Countdown date={Date.now() + 1000 * 60 * 2} renderer={renderCountDown} /> */}
                                </div>
                            </div>
                            <div id="request-sequence" className="request-sequence">
                                <h6>Transaction Sequence</h6>
                                <RequestSequence sequence={simulation.TransactionSequence} selectRequest={updateContentBasedOnSelectedRequest} currentTransaction={simulation.CurrentTransaction}></RequestSequence>
                            </div>
                        </div>
                        <div className="request-info-view">
                            <div id="request-area" className="request-view">
                                <h6>Request</h6>
                                <RequestBuilder requestJson={requestInformation}></RequestBuilder>
                            </div>
                            <div id="response-area" className="response-view">
                                <h6>Response</h6>
                                <ResponseBuilder responseJson={requestInformation}></ResponseBuilder>
                            </div>
                        </div>
                    </div>
                    <div className="demo-area">
                        <div className="btn-group terminalmodel-selection" role="group" aria-label="Basic checkbox toggle button group">
                            <div id="terminal-model-selection" className="dropdown">
                                <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    Terminal Model
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <li><a className="dropdown-item" onClick={(e) => {
                                        e.preventDefault()
                                        terminalModelSelection("C100");
                                    }}>C100 Terminal</a></li>
                                    <li><a className="dropdown-item" onClick={(e) => {
                                        e.preventDefault()
                                        terminalModelSelection("C10");
                                    }}>C10 Terminal</a></li>
                                </ul>
                            </div>
                            <div id="terminal-linking" className="form-check form-switch">
                                <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchLinking" onClick={(e) => { linkTerminal(e) }} checked={linkedTerminal} disabled={simulation.CurrentTransaction != null ? true : false} />
                                {linkedTerminal == true ?
                                    <label className="form-check-label primary" for="flexSwitchLinking">Linked</label> :
                                    <label className="form-check-label danger" for="flexSwitchLinking">Not Linked</label>
                                }
                            </div>
                            <div id="terminal-connectivity" className="form-check form-switch">
                                <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchConnecting" onClick={(e) => { terminalConnect(e) }} checked={connected} disabled={simulation.CurrentTransaction != null ? true : false} />
                                {connected == true ?
                                    <label className="form-check-label primary" for="flexSwitchConnecting">Connected</label> :
                                    <label className="form-check-label danger" for="flexSwitchConnecting">Disconnected</label>
                                }
                            </div>
                            {/* <div className="btn-group" role="group" aria-label="Basic checkbox toggle button group">
                                <input type="checkbox" className="btn-check" id="btncheck1" autocomplete="off" onClick={(e) => { linkTerminal(e) }} checked={linkedTerminal} />
                                {linkedTerminal == true ?
                                    <label className="btn btn-outline-primary" for="btncheck1">Linked</label> :
                                    <label className="btn btn-outline-danger" for="btncheck1">Not Linked </label>
                                }
                            </div> */}
                            {/* <div className="btn-group" role="group" aria-label="Basic checkbox toggle button group">
                                <input type="checkbox" className="btn-check" id="btncheck2" autocomplete="off" onClick={(e) => { terminalConnect(e) }} checked={connected} />
                                {connected == true ?
                                    <label className="btn btn-outline-primary" for="btncheck2">Connected</label> :
                                    <label className="btn btn-outline-danger" for="btncheck2">Disconnected</label>
                                }
                            </div> */}
                        </div>
                        {/*
                         * Here based on the selected action, component will be replace.
                         */}
                        <Process
                            newTransaction={newTransactionForTerminal}
                            model={terminalModel}
                            notifySimulatorBackend={(type) => updateSimulationWithResult(type)}
                            linkedTerminal={linkedTerminal}
                            setTerminalLinked={(state) => updateTerminalLinkedState(state)}
                            connected={connected}
                            setConnected={(state) => updateTerminalConnectedState(state)}
                            terminalId={terminalId}
                            setTerminalId={(state) => updateTerminalId(state)}>
                        </Process>
                    </div>
                </div>
            </div>
            <span className="fixed-help-btn" style={helpIconStyles} onClick={() => handleGuideMe()} />
            <div className='guide-me' ref={guideMeContainer}>
                <div className="guide-me-selector" ref={guideMeSelector}></div>
                <div className='guid-me--box' ref={guideMeActionBox}>
                    <div className='guid-me--content'>
                        {currentGuide && currentGuide?.intro}
                    </div>
                    <div className='guid-me--actions'>
                        <a target="_blank" rel="noreferrer" onClick={() => { clickStopGuide() }}
                            className='btn btn-danger btn-sm' role="button">Stop</a>
                        <a target="_blank" rel="noreferrer" onClick={() => { clickNextGuide() }}
                            className='btn btn-primary btn-sm' role="button">Next</a>
                    </div>
                </div>
            </div>
            <div className="docs-top-utilities d-flex justify-content-end align-items-center">
                <a href={PUBLIC_SWAGGER_URL + "/in-store/swagger/index.html"} target="_blank" rel="noreferrer"
                    className="btn btn-primary btn-swagger d-none d-lg-flex" role="button" aria-disabled="true">Swagger</a>
            </div>
        </>
    );
};

export default Simulator;